module.exports = __webpack_public_path__ + "img/4.21788f41.gif";